function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import UnorderedList from '@govuk-react/unordered-list';
import ListItem from '@govuk-react/list-item';
import { withWhiteSpace } from '@govuk-react/hoc';
/**
 *
 * ### Usage
 *
 * Simple
 * ```jsx
 * <ListNavigation>
 *   <a href="/section-a">Section A</a>
 *   <a href="/section-b">Section B</a>
 * </ListNavigation>
 * ```
 *
 * Current recommended approach using the `asAnchor` HOC for GDS styled links
 * ```jsx
 * import { asAnchor } from '@govuk-react/hoc';
 *
 * const AnchorTag = asAnchor('a');
 *
 * <ListNavigation listStyleType="square">
 *   <AnchorTag href="https://example.com/link-a">Link A</AnchorTag>
 *   <AnchorTag href="https://example.com/link-b">Link B</AnchorTag>
 * </ListNavigation>
 * ```
 *
 * Using React Router and `asAnchor` HOC for GDS styled links
 * ```jsx
 * import { Link } from 'react-router-dom';
 * import { asAnchor } from '@govuk-react/hoc';
 *
 * const AnchorLink = asAnchor(Link);
 *
 * <ListNavigation listStyleType="circle">
 *   <AnchorLink to="/link-a">Link A</AnchorLink>
 *   <AnchorLink to="/link-b">Link B</AnchorLink>
 * </ListNavigation>
 * ```
 *
 * ### References:
 * - https://govuk-static.herokuapp.com/component-guide/government_navigation
 *
 * ### TODO:
 * - Consider using the context API https://github.com/reactjs/rfcs/blob/master/text/0002-new-version-of-context.md
 * - Consider nested anchors, should developers have to use the HOC to preserve link styling?
 * - Fix active state overlaping siblings
 */

var ListNavigation = function ListNavigation(_ref) {
  var children = _ref.children,
      listStyleType = _ref.listStyleType,
      props = _objectWithoutProperties(_ref, ["children", "listStyleType"]);

  return React.createElement(UnorderedList, _extends({
    listStyleType: listStyleType
  }, props), children.length && children.map ? children.map(function (child, i) {
    return React.createElement(ListItem, {
      key: child.key || i
    }, child);
  }) : React.createElement(ListItem, null, children));
};

ListNavigation.defaultProps = {
  listStyleType: undefined
};
export default withWhiteSpace({
  marginBottom: 0
})(ListNavigation);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/list-navigation/es/index.js
// module id = 269
// module chunks = 0